import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";

import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  POST_GetReferenceStandardList,
  POST_GetReferenceStandardVerificationHistoryList,
  POST_ReferenceStandardActiveInActive,
  POST_ReferenceStandardDelete,
  POST_ReferenceStandardExport,
  POST_ReferenceStandardReviseList,
  POST_ReferenceStandardVerifiedUpdate,
} from "../../../helpers/url_helper";
import {
  ActiveInactive_Record,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { useFilter } from "../../../../context/FilterContext";

const ReferenceStandard = () => {
  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "reference-standard" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "reference-standard" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "reference-standard" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "reference-standard" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [referenceStandardsHistoryModal, setReferenceStandardsHistoryModal] =
    useState(false);

  const [referenceStandardsList, setReferenceStandardsList] = useState([]);
  const [showReviseHistoryModal, setShowReviseHistoryModal] = useState(false);
  const [referenceStandardReviseHistory, setReferenceStandardReviseHistory] =
    useState([]);
  const [referenceStandardHistoryList, setReferenceStandardHistoryList] =
    useState([]);
  const [referenceStandardVerifiedModal, setReferenceStandardVerifiedModal] =
    useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Status:
        filter && filter?.page == "reference-standard" ? filter?.Status : -1,
      Search:
        filter && filter?.page == "reference-standard" ? filter?.Search : "",
      // Search: "",
      // Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, Status },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: -1,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "reference-standard",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    await post(POST_GetReferenceStandardList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setReferenceStandardsList(response?.ReferenceStandardsList);
        setIsLoading(false);
        if (page > 1 && response?.ReferenceStandardsList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_ReferenceStandardExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const ReferenceStandard_ReviseHistory = (ReferenceStandardID) => {
    setReferenceStandardReviseHistory("");
    setReferenceStandardHistoryList("");
    setShowReviseHistoryModal(true);
    GetReferenceStandardHistList(ReferenceStandardID);
    setIsLoading(true);

    let payload = {
      ReferenceStandardIDEncrypt: ReferenceStandardID,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_ReferenceStandardReviseList, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          setReferenceStandardReviseHistory(response?.ReferenceStandardsList);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const GetReferenceStandardHistList = (ReferenceStandardID) => {
    setIsLoading(true);

    let payload = {
      ReferenceStandardIDEncrypt: ReferenceStandardID,
    };
    post(POST_GetReferenceStandardVerificationHistoryList, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          setReferenceStandardHistoryList(response?.VerificationHistoryList);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaReferenceStandardVerified = Yup.object().shape({
    VerificationRemarks: Yup.string()
      .trim()
      .required("Verification Remarks is required field"),
  });

  const formikReferenceStandardVerified = useFormik({
    validationSchema: validationSchemaReferenceStandardVerified,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitReferenceStandardVerified(values, formikHelpers),
    initialValues: {
      ReferenceStandardIDEncrypt: "",
      VerificationRemarks: "",
      ReferenceStandard: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { ReferenceStandard },
  } = formikReferenceStandardVerified;

  const handleValidSubmitReferenceStandardVerified = (values) => {
    setIsLoading(true);
    let payload = {
      ...values,
      ReferenceStandardIDEncrypt: values.ReferenceStandardIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,

      VerificationRemarks: values.VerificationRemarks,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(POST_ReferenceStandardVerifiedUpdate, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          //swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            formikReferenceStandardVerified.resetForm();
            setReferenceStandardVerifiedModal(false);
            getData();
          }, 1000);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    setIsLoading(false);
  };

  const ReferenceStandard_Verified = (
    ReferenceStandardID,
    ReferenceStandard
  ) => {
    formikReferenceStandardVerified.resetForm();
    setReferenceStandardVerifiedModal(true);
    formikReferenceStandardVerified.setFieldValue(
      "ReferenceStandardIDEncrypt",
      ReferenceStandardID
    );
    formikReferenceStandardVerified.setFieldValue(
      "ReferenceStandard",
      ReferenceStandard
    );
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Reference Standard</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                    //setShowFilter(false);
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 23 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    // className="btn btn-primary light btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 23 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="/add-reference-standard"
                    // className="btn btn-primary btn-sm"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa-solid fa-plus"></i> Add Reference Standard
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                            autoFocus={isFilterExpanded}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Status"
                            name="Status"
                            placeholder={"Select Status"}
                            options={statusOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>

                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                // className="btn btn-primary btn-sm mb-1"
                                className="btn btn-primary btn-sm mb-1"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>{" "}
                                Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="ReferenceStandards-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="ReferenceStandards-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="6%"></th>
                      <th
                        style={{
                          width: "18%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("ReferenceStandard");
                        }}
                      >
                        Reference Standard{" "}
                        <span className="ml-1">
                          {sortBy == "ReferenceStandard" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "21%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("DepartmentName");
                        }}
                      >
                        Department{" "}
                        <span className="ml-1">
                          {sortBy == "DepartmentName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "21%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("ProductGroupName");
                        }}
                      >
                        Material Group{" "}
                        <span className="ml-1">
                          {sortBy == "ProductGroupName" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "18%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("IsVerified");
                        }}
                      >
                        Verified{" "}
                        <span className="ml-1">
                          {sortBy == "IsVerified" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "8%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("VerificationValidityDate");
                        }}
                      >
                        Expired Date{" "}
                        <span className="ml-1">
                          {sortBy == "VerificationValidityDate" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "8%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("EffectiveDate");
                        }}
                      >
                        Revised Date{" "}
                        <span className="ml-1">
                          {sortBy == "EffectiveDate" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {referenceStandardsList?.length > 0 ? (
                      referenceStandardsList?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 23 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/edit-reference-standard/${window.btoa(
                                  item.ReferenceStandardIDEncrypt
                                )}`}
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 23 && x?.IsActive
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className={`icon-box icon-box-md bg-${
                                //   item.IsActive == true ? "success" : "danger"
                                // }-light me-1`}
                                className={`icon-box icon-box-md me-1`}
                                title={
                                  item.IsActive == true ? "Active" : "Inactive"
                                }
                                onClick={() => {
                                  ActiveInactive_Record(
                                    item.IsActive,
                                    POST_ReferenceStandardActiveInActive,
                                    {
                                      ReferenceStandardIDEncrypt:
                                        item.ReferenceStandardIDEncrypt,
                                      IsActive: !item.IsActive,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.ReferenceStandard
                                  );
                                }}
                              >
                                <i
                                  className={`fa fa-circle fs-15 ${
                                    item.IsActive == true
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                ></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 23 && x?.IsDelete
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-danger-light"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                onClick={() => {
                                  delete_Record(
                                    POST_ReferenceStandardDelete,
                                    {
                                      ReferenceStandardIDEncrypt:
                                        item.ReferenceStandardIDEncrypt,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.ReferenceStandard
                                  );
                                }}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 23 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Verify"
                                onClick={() => {
                                  ReferenceStandard_Verified(
                                    item.ReferenceStandardIDEncrypt,
                                    item.ReferenceStandard
                                  );
                                }}
                              >
                                {/* <i className="fa fa-check-circle"></i> */}

                                {item.IsVerified
                                  ? SVGICON.Verified
                                  : SVGICON.Unverified}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 23 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/revise-reference-standard/${window.btoa(
                                  item?.ReferenceStandardIDEncrypt
                                )}`}
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Revise"
                              >
                                <i className="fa fa-refresh"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            <Link
                              className="icon-box icon-box-md me-1"
                              title="History"
                              onClick={() => {
                                ReferenceStandard_ReviseHistory(
                                  item.ReferenceStandardIDEncrypt
                                );
                              }}
                            >
                              <i className="fa fa-history"></i>
                            </Link>
                          </td>
                          <td> {item.ReferenceStandard}</td>

                          <td
                            style={{ textAlign: "left", cursor: "pointer" }}
                            className="popupOverlay"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.Departments}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.Departments}</span>
                            </OverlayTrigger>
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            className="popupOverlay"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.ProductGroups}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.ProductGroups}</span>
                            </OverlayTrigger>
                          </td>
                          <td>
                            {item.IsVerified ? "Yes" : "No"}
                            {" - "}
                            {item.VerificationDoneBy} {" - "}
                            {item.VerificationDateTime}
                          </td>
                          <td>{item.VerificationValidityDate}</td>
                          <td style={{ textAlign: "left" }}>
                            {item.EffectiveDate}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showReviseHistoryModal}
          onHide={setShowReviseHistoryModal}
          size="xl"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div>
              <Modal.Header>
                <Modal.Title>Reference Standard Revise History</Modal.Title>
                <div className="d-flex align-items-center">
                  <div>
                    <Link
                      to="#"
                      className="text-primary"
                      onClick={() => {
                        setReferenceStandardsHistoryModal(true);
                      }}
                    >
                      View Reference Standards History
                    </Link>
                  </div>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowReviseHistoryModal(false)}
                  ></button>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="table-responsive active-projects style-1 shorting">
                  <div
                    id="Reference-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="Reference-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead className="thead-light">
                        <tr>
                          <th width="5%">Sr No</th>
                          <th width="20%">Reference Standard</th>
                          <th width="30%">Department</th>
                          <th width="30%">Material Group</th>
                          <th width="10%">Effective Date</th>
                          <th width="5%" style={{ textAlign: "left" }}>
                            File
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {referenceStandardReviseHistory?.length > 0 ? (
                          referenceStandardReviseHistory?.map((item, indx) => (
                            <tr key={indx}>
                              <td
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                                className="p-1"
                              >
                                {indx + 1}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                                className="p-1"
                              >
                                {item?.ReferenceStandard}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                                className="p-1"
                              >
                                {item.Departments}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                                className="p-1"
                              >
                                {item.ProductGroups}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                                className="p-1"
                              >
                                {item?.EffectiveDate}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "normal",
                                  verticalAlign: "top",
                                }}
                              >
                                {item?.ReferenceDocFilePath ? (
                                  <Link
                                    to="#"
                                    className="fs-14"
                                    title="Download"
                                    onClick={() => {
                                      window.open(
                                        item?.ReferenceDocFilePath,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    {SVGICON.Download}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={6}
                              style={{
                                textAlign: "left",
                              }}
                            >
                              <div className="mt-1 ml-1 mb-2">
                                {"No Record Found..."}
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Modal.Body>
              {referenceStandardsHistoryModal == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </div>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={referenceStandardsHistoryModal}
          onHide={setReferenceStandardsHistoryModal}
          size="xl"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div>
              <Modal.Header>
                <Modal.Title>
                  Reference Standard Verification History
                </Modal.Title>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setReferenceStandardsHistoryModal(false)}
                  ></button>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="table-responsive active-projects style-1 shorting">
                  <div
                    id="ReferenceStandards-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="ReferenceStandards-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead className="thead-light">
                        <tr role="row">
                          <th>Reference Standard</th>
                          <th>Verification Done By</th>
                          <th>Verification Date</th>
                          <th style={{ textAlign: "left" }}>
                            Verification Validity Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {referenceStandardHistoryList?.length > 0 ? (
                          referenceStandardHistoryList?.map((History, idx) => (
                            <tr role="row" className="odd" key={idx}>
                              <td>{History.ReferenceStandard}</td>
                              <td>{History.VerificationDoneByName}</td>
                              <td>{History.VerificationDateTime}</td>
                              <td style={{ textAlign: "left" }}>
                                {History.VerificationValidityDate}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={4}
                              style={{
                                textAlign: "left",
                              }}
                            >
                              <div className="mt-1 ml-1 mb-2">
                                {"No Record Found..."}
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Modal.Body>
            </div>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={referenceStandardVerifiedModal}
          onHide={setReferenceStandardVerifiedModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikReferenceStandardVerified}>
              <Form onSubmit={formikReferenceStandardVerified.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    Reference Standard Verified ({ReferenceStandard})
                  </Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setReferenceStandardVerifiedModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Verification Remarks"
                        name="VerificationRemarks"
                        rows={5}
                        placeholder={"Enter Verification Remarks"}
                        component={CustomTextArea}
                        maxLength={500}
                        required
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    // className="btn me-2 btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Verify
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={() => setReferenceStandardVerifiedModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default ReferenceStandard;
